// GET /api/selfcare/usage?days=N — kunlik trafik tarixi.
// HAQIQIY backend kontrakti (`xsib-core/selfcare/internal/UsageController.java`):
// javob maydoni `date` EMAS, `day` (`YYYY-MM-DD`, UTC kun chegarasi).
//
// `days` — ixtiyoriy, standart 30, backend 90 kungacha ruxsat beradi
// (`MAX_DAYS`). `uploadBytes` = abonent YUBORGAN, `downloadBytes` = abonent
// OLGAN — UI'da aynan shu ma'noda ko'rsatilsin (`UsageController` javadoc'i).

import { z } from 'zod'
import { api } from '@/shared/api/client'

const dayUsageSchema = z.object({
  day: z.string(),
  uploadBytes: z.number(),
  downloadBytes: z.number(),
  totalBytes: z.number(),
  freeBytes: z.number().default(0),
})

const usageResponseSchema = z.array(dayUsageSchema)

export interface DayUsage {
  day: string
  uploadBytes: number
  downloadBytes: number
  totalBytes: number
  freeBytes: number
}

export interface UsageSummary {
  totalBytes: number
  freeBytes: number
  countedBytes: number
}

export function parseUsage(raw: unknown): DayUsage[] {
  return usageResponseSchema.parse(raw)
}

export function summarizeUsage(days: DayUsage[]): UsageSummary {
  const totalBytes = days.reduce((sum, d) => sum + d.totalBytes, 0)
  const freeBytes = days.reduce((sum, d) => sum + d.freeBytes, 0)
  return { totalBytes, freeBytes, countedBytes: totalBytes - freeBytes }
}

export async function fetchUsage(days?: number): Promise<DayUsage[]> {
  const response = await api.get<unknown>('/api/selfcare/usage', {
    params: days ? { days } : undefined,
  })
  return parseUsage(response.data)
}
